import {IntermediatePart} from "../../intermediatePart";

export default class PonyWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'pony_wall';
    this.visible = true;
    this.partName = 'Pony Wall';
    this.translateId = "visualizer.bathroom.walls.pony_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    if (dbFeature.metaData["Part"]) {
      const partNumber = +dbFeature.metaData["Part"][0];
      return this.load_(dbFeature, new this.constructor(false, partNumber), true, partNumber === 0 ? 'features' : 'featuresParts');
    }
    return this.load_(dbFeature, new this.constructor());
  }
}
